import { isContractInProgressAt } from '@libs/data-access/queries'
import type { ReduxState } from '@spa/redux/ReduxState'
import { useMemoSelector } from '@spa/redux/hooks'
import { getContractsByTeamId } from 'snap-redux/modules/contracts/selectors'
import { getPlannableMembershipsByIds } from 'snap-redux/modules/memberships/selectors'

/**
 * @deprecated use the new one please
 */
const usePlannableContractsLegacy = (
  shiftDateISO: string,
  weeklyScheduleTeamId: number
) => {
  const contracts = useMemoSelector((state: ReduxState) =>
    getContractsByTeamId(state, weeklyScheduleTeamId).filter(contract =>
      isContractInProgressAt(contract, shiftDateISO)
    )
  )
  const membershipsIds = contracts
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    .map(contract => contract.membership_id)
    .toArray()

  const memberships = useMemoSelector(state =>
    getPlannableMembershipsByIds(state, membershipsIds)
  )

  return contracts.filter(contract =>
    Boolean(
      // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
      memberships.find(membership => membership.id === contract.membership_id)
    )
  )
}

export default usePlannableContractsLegacy
